import React from 'react';

const createSubjectList = res => {
  return res.map(({ name }) => name);
};

export default createSubjectList;
